module.exports = __webpack_public_path__ + "img/review-copy.8cd70b2b.svg";